export const formatCredits = (minor) => (Number(minor) / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const formatDisplayCredits = (minor = 0, compact = false) => {
  const absolute = Math.abs(minor);
  const amount = compact && absolute >= 100000000
    ? new Intl.NumberFormat('en-US', { notation: 'compact', maximumFractionDigits: 2 }).format(absolute / 100)
    : formatCredits(absolute);
  return `${minor < 0 ? '-' : ''}${amount}`;
};
export const toMinor = (value) => {
  const amount = Number(value);
  const minor = Math.round(amount * 100);
  return Number.isFinite(amount) && Math.abs(amount * 100 - minor) < 0.00001 && minor > 0 ? minor : null;
};
const DEMO_KEY = "gv_keno_demo_v1";
export const readDemoWallet = () => {
  try {
    const saved = JSON.parse(localStorage.getItem(DEMO_KEY));
    if (Number.isSafeInteger(saved?.balance_minor) && saved.balance_minor >= 0 && Number.isSafeInteger(saved.revision) && saved.revision >= 0 && Array.isArray(saved.rounds) && saved.rounds.every((round) => Number.isSafeInteger(round.bet_minor) && Number.isSafeInteger(round.payout_minor) && typeof round.request_id === "string")) return { ...saved, rounds: saved.rounds.slice(-50) };
  } catch { /* A broken practice save must never affect an account wallet. */ }
  return { balance_minor: 100000, revision: 0, rounds: [] };
};
export const saveDemoWallet = (wallet) => localStorage.setItem(DEMO_KEY, JSON.stringify(wallet));